import { _x } from '@safe-wordpress/i18n';

export const browsersList = {
	'Opera Mini': 'Opera Mini',
	'Opera Mobi': 'Opera Mobi',
	'Samsung Browser': _x( 'Samsung Browser', 'text', 'nelio-ab-testing' ),
	Chrome: 'Chrome',
	Chromium: 'Chromium',
	Edge: 'Edge',
	Firefox: 'Firefox',
	Mozilla: 'Mozilla',
	Opera: 'Opera',
	Safari: 'Safari',
	Vivaldi: 'Vivaldi',
};
